import '../../stylesheets/PoiList.css';
import { selectAllStrings, selectCurrentLanguage } from '../language/languageSlice';
import { useSelector, useDispatch } from 'react-redux';
import { constants } from '../../constants';
import React, { useState } from 'react';
import { selectPoiById } from './poisSlice';
import { parsePoiAdvantages, parseTrendingPoiAdvantages } from './parser';
import SearchModal from './SearchModal';
import { searchPois } from './poisSlice';
import { useHistory } from 'react-router-dom';
import StarIcon from '../../app/icons/StarIcon';

export const PoiRating = ({rating, onClick=f=>f, validation=false, hideEmpty=false}) => <div className="rating">
{hideEmpty && rating == 0 ? null : [1, 2, 3, 4, 5].map((number) => (<i className={number <= rating ? 'filled-star' : 'star'} key={number} onClick={() => onClick(number)}><StarIcon/></i>))}
        {validation ? <input type="text" readOnly required value={rating ? rating : ''} style={{height: 0, padding: 0, display: 'inline-block'}} /> : null}
        </div>;

let Poi = ({poiId, selector, poiType}) => {
    const strings = useSelector(selectAllStrings);
    const poi = useSelector((state) => selector(state, poiId));
    const currentLanguage = useSelector(selectCurrentLanguage);
    const history = useHistory();
    
    let categoryImage = null;
    if(poi.cat_camping == 1) {
        categoryImage = constants.backend_url + '/images/campeggi.png';
    } else if(poi.cat_areeservizio == 1) {
        categoryImage = constants.backend_url + '/images/servizi.png';
    } else if(poi.cat_convenzioni == 1) {
        categoryImage = constants.backend_url + '/images/vantaggi.png';
    } else if(poi.cat_areesosta == 1) {
        categoryImage = constants.backend_url + '/images/sosta.png';
    }

    return <div className={"poi"+(poi.cat_convenzioni === '1' || poi.CON === '1' ? ' club-benefits': '')} key={poiId} onClick={event => history.push(`/pois/${poiId}`)}>
        <div className="image">
            <img alt="poi" src={poi.square_image || poi.image || poi.large_image || categoryImage }/>
        </div>
        <span className="title">{poi.nome_poi}</span>
        <span className="advantages">{
                    poiType == 'trending' ? parseTrendingPoiAdvantages(poi, strings) : parsePoiAdvantages(poi, strings)
            }</span>
        <div className="description" dangerouslySetInnerHTML={{__html: currentLanguage == 'en' ? (poi.desc_poi_en || poi.desc_en) : (poi.desc_poi || poi.desc)}}></div>
        {typeof poi.average !== 'undefined' ?  <PoiRating rating={poi.average} /> : null}
        <div className="distance">{poi.distance ? poi.distance + ' ' + strings.km : null}</div>
    </div>
};
Poi = React.memo(Poi);
const PoiList = ({poiIds, status, error, onGoBack, selectById, poiType, onLoadMore=null}) => {
    const strings = useSelector(selectAllStrings);
    const [showSearch, setShowSearch] = useState(false);
    const [keyword, setKeyword] = useState('');
    const dispatch = useDispatch();
    const history = useHistory();
    const loadingMore = useSelector((state) => state.pois.loadingMore);


    const applyFilters = async (filters, address) => {
        if (!filters.location) {
            alert(strings.geolocation_error);
        } else {
            dispatch(searchPois({
                    keyword: filters.poiKeyword,
                lat: filters.location.lat(),
                lng: filters.location.lng(),
                camp: filters.campsites,
                serv: filters.serviceAreas,
                sosta: filters.parkingAreas,
                conv: filters.clubBenefits,
                attr: filters.attractions,
                acc: filters.disabledAccessibility,
                pet: filters.petsAllowed,
                water: filters.water,
                cp: filters.cockpit,
                el: filters.electricity,
                limit: 10
            }));
            setKeyword(address);
            setShowSearch(false);
            history.replace('/search-poi');
        }
    };

    let content = status === 'loading' ? <div className="loader"></div> : status === 'succeeded' ?
            poiIds.length > 0 ? poiIds.map((poiId) => <Poi key={poiId} poiId={poiId} selector={selectById} poiType={poiType}/>)
            : <p>{strings.no_results_found}</p>
            :
            status === 'error' ? <div>{error}</div> : null;

    const loadMore = (event) => {
        event.preventDefault();
        onLoadMore();
    };

    return <div className="poi-list-page">
        <div className="header">
            <a className="go-back" onClick={onGoBack}></a>
            <h1>{strings.search_poi}</h1>
        </div>
        <div id="search_wrapper">
            <input type="text" id="search_poi" className="search" value={keyword} readOnly placeholder={strings.search_poi} onClick={event => setShowSearch(true)} />
        </div>
        <div className="poi-list">
            {content}
        </div>
        {poiIds.length >= 10 && onLoadMore !== null ? <button className="btn" id="load_more" disabled={loadingMore} onClick={loadMore}>
        {
        loadingMore ? <div className="loader"></div> : strings.load_10}</button> : null
                            }
                            
        <SearchModal show={showSearch} onGoBack={() => setShowSearch(false)} onApplyFilters={applyFilters}/>
    </div>
};

export default PoiList;